// generic 3 statuses for any use case
export enum NotificationBarStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  NULL = 'NULL',
}
